import { Box, BoxProps, Radio, RadioProps, styled } from "@mui/material";

const ColoredRadio = styled(Radio)<RadioProps>(() => ({
	color: "transparent",
	borderRadius: "11px",
	width: "37px",
	height: "37px",
	zIndex: 1,
	visibility: "hidden",
	"&.Mui-checked": {
		visibility: "visible",
	},
}));
const CircleCover = styled(Box)<BoxProps>((props: any) => ({
	width: "35.5px",
	height: "35.5px",
	borderRadius: "10px",
	backgroundColor: props.color,
	position: "absolute",
	top: "1px",
	left: "1px",
}));

export default function ColoredRadioButton(props: any) {
	const { color, ...rest } = props;
	const isLight = isLightColor(color);

	return (
		<div style={{ position: "relative", width: "fit-content" }}>
			<ColoredRadio style={{ color: isLight ? "black" : "white" }} {...rest} />
			<CircleCover color={color} />
		</div>
	);
}

function isLightColor(color: string) {
	let c = color;
	if (c.startsWith("#")) {
		c = c.substring(1); // strip #
	}

	const rgb = parseInt(c.substring(0, 6), 16); // convert rrggbb to decimal
	const r = (rgb >> 16) & 0xff; // extract red
	const g = (rgb >> 8) & 0xff; // extract green
	const b = (rgb >> 0) & 0xff; // extract blue

	let alpha = 1; // default alpha
	if (c.length === 8) {
		// if alpha is provided
		alpha = parseInt(c.substring(6, 8), 16) / 255;
	}

	// blend with white background
	const rFinal = r * alpha + 255 * (1 - alpha);
	const gFinal = g * alpha + 255 * (1 - alpha);
	const bFinal = b * alpha + 255 * (1 - alpha);

	const luma = 0.2126 * rFinal + 0.7152 * gFinal + 0.0722 * bFinal; // per ITU-R BT.709

	return luma > 128;
}
